import mapValues from 'lodash/mapValues';
import guava from 'brands/guava';
import evp from 'brands/evp';
import taktuno from 'brands/taktuno';

// Brands of other apps are aliased out of the bundle and import empty
const brands = mapValues({ guava, evp, taktuno }, (brand, id) => brand && { ...brand, id });

export const buildBrand = brands[process.env.REACT_APP_BRAND];

export const findServedBrand = (id) => {
  const brand = brands[id];

  return brand?.servedByApp === buildBrand.servedByApp ? brand : undefined;
};
